import PropTypes from 'prop-types';
import React from 'react';
import ComponentFactory from '../../shared/utils/ComponentFactory';
import { actions as sessionActions } from '../../actions/SessionActions';
import { actions as formActions } from '../../actions/FormActions';
import { actions as settingsActions } from '../../actions/SettingsActions';
import { actions as fedopsActions } from '@wix/restaurants-redux/dist/actions/FedopsActions';
import SeatingApp from '../../shared/components/SeatingApp';

export default ComponentFactory({
        displayName: 'SeatingAppContainer',

        propTypes: {
            compId: PropTypes.string
        },

        getDefaultProps() {
            return {
                compId: ''
            };
        },

        componentWillMount() {
            const { sessionActions } = this.props;
            sessionActions.initSession();
        },

        render() {
            const { session, settings, form, styles, restaurant, formActions, sessionActions, settingsActions,
                fedopsActions, compId } = this.props;

            return (
                <SeatingApp session={session}
                            settings={settings}
                            form={form}
                            compId={compId}
                            styles={styles}
                            restaurant={restaurant}
                            formActions={formActions}
                            sessionActions={sessionActions}
                            fedopsActions={fedopsActions}
                            settingsActions={settingsActions}/>
            );
        }

    }, state => ({session: state.seatingSession, settings: state.seatingSettings, form: state.seatingForm,
        styles: state.styles.styles, restaurant: state.organization.organization}),
    {formActions, sessionActions, settingsActions, fedopsActions});
